// extracted by mini-css-extract-plugin
export default {"emailsContainer":"POCEmailContainer_emailsContainer__IJGg5","emailContainer":"POCEmailContainer_emailContainer__znD7H"};